import React from 'react';
import { BookOpen, SearchX, RotateCcw } from 'lucide-react';

interface BookListEmptyProps {
  onAddBook: () => void;
  searchKeyword?: string;
  onClearSearch?: () => void;
}

export const BookListEmpty: React.FC<BookListEmptyProps> = ({
  onAddBook,
  searchKeyword,
  onClearSearch,
}) => {
  const isSearching = Boolean(searchKeyword && searchKeyword.trim().length > 0);

  return (
    <div className="p-12 text-center bg-white rounded-2xl border border-slate-200 shadow-2xs">
      {isSearching ? (
        <>
          <div className="w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-3">
            <SearchX className="w-6 h-6" />
          </div>
          <h3 className="text-base font-bold text-slate-800">Tidak ada buku yang cocok</h3>
          <p className="text-xs text-slate-500 max-w-sm mx-auto mt-1 leading-relaxed">
            Tidak ditemukan buku dengan kata kunci <span className="font-semibold text-slate-700">&quot;{searchKeyword}&quot;</span>. Coba periksa kembali ejaan judul atau nama penulis buku Anda.
          </p>
          <div className="mt-4 flex flex-wrap items-center justify-center gap-2">
            {onClearSearch && (
              <button
                type="button"
                onClick={onClearSearch}
                className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-xl text-xs font-semibold cursor-pointer transition flex items-center gap-1.5 shadow-2xs"
              >
                <RotateCcw className="w-3.5 h-3.5" />
                <span>Reset Pencarian</span>
              </button>
            )}
            <button
              type="button"
              onClick={onAddBook}
              className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-semibold cursor-pointer transition shadow-2xs"
            >
              Daftarkan Buku Baru
            </button>
          </div>
        </>
      ) : (
        <>
          <BookOpen className="w-10 h-10 text-slate-300 mx-auto mb-2.5" />
          <h3 className="text-sm font-bold text-slate-800">Tidak ada buku ditemukan</h3>
          <p className="text-xs text-slate-500 max-w-sm mx-auto mt-1">
            Belum ada buku dengan kriteria ini. Tambahkan buku baru untuk membuat kode UIBN pertama Anda.
          </p>
          <button
            type="button"
            onClick={onAddBook}
            className="mt-4 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-xs font-semibold cursor-pointer transition shadow-2xs"
          >
            Daftarkan Buku Baru
          </button>
        </>
      )}
    </div>
  );
};
